import React from "react";
import { Col, Form } from "react-bootstrap";
import { ErrorMessage } from "@hookform/error-message";

function Password(props) {
  return (
    <Form.Group as={Col} controlId="">
      <Form.Label>Password</Form.Label>
      <Form.Control
        type="password"
        placeholder="Password"
        {...props.register("password", {
          pattern: {
            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
            message:
              "Password must be a minimum of 8 characters with one upper case letter, one lower case letter, and one number",
          },
          required: { value: true, message: "This field is required" },
        })}
      />
      <ErrorMessage
        errors={props.errors}
        name="password"
        render={({ message }) => <div style={{ color: "red" }}>{message}</div>}
      />
    </Form.Group>
  );
}
export default Password;
